export const WebLink = {
  HOME: '/',
  LOGIN: '/giris-yap',
  SIGNUP: '/kayit-ol',
  PROFILE: '/profilim',
  ORDER_DETAIL: (orderNumber: string, orderId?: number) =>
    orderId
      ? `/profilim/siparis/${orderNumber}?orderId=${orderId}`
      : `/profilim/siparis/${orderNumber}`,
  CART: '/sepetim',
  CHECKOUT: '/satin-al-alici-bilgileri',
  ORDER_RECEIVED: '/siparis-alindi',
  ORDER_PAYMENT_FAILED: '/siparis-odeme-hatasi',
  CHECKOUT_LOGIN: '/sepet-uyelik',
  PRODUCTS: '/urunler',
  ERROR_FALLBACK: '/log-out',
  NOT_FOUND: '/404',
  PRIVACY: '/satis-sozlesmesi',
  BLOGS: '/blog',
  FORGOT_PASSWORD: '/sifremi-unuttum',
  MOBILE_ROUTE: '/mobile-route',
  MOBILE_AUTH: '/mobile-auth',
  MOBILE_APP_PROMO: '/uygulama',
};
